<template>
  <div>

    <div class="row mt-4">
      <div class="col-md-8">
        <input
          class="input form-control"
          @keypress.enter="find()"
          v-model="query.generic"
          placeholder="Pesquisar por mensagem"
        >

        <search-icon @click="find()" class="icon icon-within"/>
      </div>

      <button class="col-md-1 ml-2 btn-sm btn-outline"
              :class="{ 'btn-outline-active': showFilter }"
              @click="showFilter = !showFilter">
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>

      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <div class="row">
      <div class="col-md-12">
        <BadgeFilters :query="query" @clearBadge="find()" @clearAllBadges="find()"
                      :amount-changed="updateNumberOfBadges"
                      :filters="[filterApp, filterActionType, filterAccount, filterImportant,
                      filterEmail, filterType, filterStartDate, filterEndDate]"/>
      </div>
    </div>

    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-3">
          <label>App/Módulo</label>
          <Select2 :options="filterApp" v-model="query.app"/>
        </div>

        <div class="col-md-3">
          <label>Ação</label>
          <Select2 :options="filterActionType" v-model="query.actionType"/>
        </div>

        <div class="col-md-3">
          <label>Contas</label>
          <Select2 :options="filterAccount" v-model="query.accountId" title-load="Carregando contas..."/>
        </div>

        <div class="col-md-3">
          <label>Emails</label>
          <Select2 :options="filterEmail" v-model="query.user_email" title-load="Carregando emails..."/>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-3">
          <label for="start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="start-date" class="form-control">
        </div>

        <div class="col-md-3">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>

        <div class="col-md-3">
          <label for="event-important">Importante?</label>
          <select v-model="query.important" id="event-important" class="form-control">
            <option v-for="opt in filterImportant.table" :value="opt.value" :key="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>
        
        <div class="col-md-3">
          <label>Tipo de Evento</label>
          <Select2 :options="filterType" v-model="query.type"/>
        </div>
      </div>
    </template>
    <hr>

    <div class="row">
      <div class="col-sm-12">

        <div class="row mt-4">
          <div class="col-md-12">
            <strong>
              {{infoTotalModels}}
            </strong>
          </div>
        </div>

        <table class="table table-borderless table-align table-h51">
          <thead>
            <tr>
              <th :title="importantTitle">Importante</th>
              <th>ID</th>
              <th>Data e hora</th>
              <th>Conta</th>
              <th>Usuário</th>
              <th>App/Módulo</th>
              <th>Tipo</th>
              <th>Mensagem</th>
              <th>Ação</th>
              <th>Detalhes</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="event in events" :key="event.id">
              <td :class="buildClass(event)">
                <BkpsCheckBox @input="changeEvent(event)" v-model="event.important"/>
              </td>
              <td>{{ event.id }}</td>
              <td>{{ event.createdAt | datetime }}</td>
              <td>{{ getAccountName(event) }}</td>
              <td>{{ event.userEmail }}</td>
              <td>{{ event.bkpsModule }}</td>
              <td>{{ event.eventType }}</td>
              <td @mouseup="copyText">
                <div class="event-message">{{ event.message }}</div>
              </td>
              <td>{{ event.action }}</td>
              <td><button @click="showDetail(event)" class="btn btn-outline">Detalhes</button></td>
            </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>

      </div>
    </div>

    <Modal v-if="currentEvent" v-model="showModal">
      <div slot="header">
        <p><strong class="modal-message">{{ currentEvent.message }}</strong></p>
      </div>

      <div class="row">
        <div class="col-md-6">
          <p><strong>ID: </strong>{{ currentEvent.id }}</p>
          <p><strong>Criado em: </strong>{{ currentEvent.createdAt | datetime }}</p>
          <p><strong>Conta: </strong>{{ getAccountName(currentEvent) }}</p>
          <p><strong>Usuário: </strong>{{ currentEvent.userEmail }}</p>
          <p><strong>App/Módule: </strong>{{ currentEvent.bkpsModule }}</p>
          <p><strong>Tipo: </strong>{{ currentEvent.eventType }}</p>
        </div>
        <div class="col-md-6">
          <p><strong>Importante: </strong>{{ currentEvent.important }}</p>
          <p><strong>Mensagem de Systema: </strong>{{ currentEvent.system }}</p>
          <p><strong>Mensagem de Formatada: </strong>{{ currentEvent.htmlMessage }}</p>
          <p><strong>Email: </strong>{{ currentEvent.userEmail }}</p>
          <p><strong>UserId: </strong>{{ currentEvent.userId }}</p>
        </div>
      </div>

      <hr>
      <div class="row">
        <div class="col-md-12 text-center">
          <button class="btn btn-outline btn-lg" @click="download">
            Baixar
          </button>
        </div>
      </div>

      <hr>
      <h3>Detalhes</h3>
      <EventDetailJson
        :data="currentEvent.detail"
        :filename="`detail_${currentEvent.id}.json`"
      />

      <hr>
      <h3>Metadata</h3>
      <EventDetailJson
        :data="currentEvent.metadata"
        :deep="1"
        :filename="`metadata_${currentEvent.id}.json`"
      />

    </Modal>

  </div>
</template>

<script>
  import BadgeFilters from '@/components/shares/BadgeFilters'
  import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'
  import DownloadCreator from '@/models/DownloadCreator'
  import EventDetailJson from '@/components/shares/EventDetailJson'

  import Pagination from '@/components/shares/specialTag/Pagination'
  import Modal from '@/components/shares/specialTag/Modal'
  import ModelMapper from '@/mixins/ModelMapper'

  import Select2 from '@/components/shares/Select2'

  import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
  import { Filter } from '@/models/filter'

  export default {
    components: { BadgeFilters, BkpsCheckBox, ChevronDownIcon, EventDetailJson, Modal, Pagination, SearchIcon, Select2 },
    computed: {
      events() {
        return this.getModels || []
      },
      importantTitle() {
        return 'Eventos marcados não serão apagados\nEventos não marcados serão apagados após 1 ano!'
      },
    },
    created() {
      const date = new Date()
      date.setDate(date.getDate())
      this.$set(this.query, 'startDate', date.toISOString().substring(0, 10))

      this.$set(this.query, 'important', '')
      this.addOrderBy('createdAt')

      this.defaultModelSetting.updateQueryURL = true
      this.asyncTemplateSelect({
        byURL: true,
        pagination: true
      })
      
      this.filterAccount = this.buildFilterAccount(this.allAccounts.data)
      this.filterEmail = this.buildFilterEmail(this.allUsers.data)
    },
    data() {
      return {
        currentEvent: null,
        filterAccount: null,
        filterActionType: new Filter({
          key: 'actionType',
          label: 'Ação',
          table: [
            ['Inserção', 'insert'],
            ['Atualização', 'update'],
            ['Remoção', 'delete'],
            ['Seleção', 'select']
          ]
        }),
        filterApp: new Filter({
          key: 'app',
          label: 'App',
          table: ['account', 'api', 'application', 'archive', 'associate',
            'calendar', 'dfe', 'dte', 'message', 'payment_service', 'recovery', 'report', 'tools']
        }),
        filterEmail: null,
        filterEndDate: new Filter({
          key: 'endDate',
          label: 'Data final',
          type: 'date'
        }),
        filterImportant: new Filter({
          key: 'important',
          label: 'Importante',
          table: [['Todos', ''], ['Sim', 'true'], ['Não', 'false']]
        }),
        filterStartDate: new Filter({
          key: 'startDate',
          label: 'Data inicial',
          type: 'date'
        }),
        filterType: new Filter({
          key: 'type',
          label: 'Tipo',
          table: [
            ['Informação', 'info'],
            ['Atenção', 'warning'],
            ['Erro', 'error'],
            ['Erro Gravíssimo', 'exception']
          ]
        }),
        modelPathPrefix: 'admin',
        nameModel: 'Event',
        showModal: false,
      }
    },
    inject: ['allAccounts', 'allUsers', 'buildFilterAccount', 'getAccountName'],
    methods: {
      download() {
        const string = JSON.stringify(this.currentEvent, null, 2)
        DownloadCreator.download(`event_${this.currentEvent.id}.json`, string)
      },
      buildClass(event) {
        if (event.eventType === 'error' || event.eventType === 'exception')
          return 'marker-red'
        else if (event.eventType === 'warning')
          return 'marker-yellow'
      },
      buildFilterEmail(users) {
        return new Filter({
          key: 'user_email',
          label: 'E-mail',
          table: users.map(e => e.email)
        })
      },
      changeEvent(event) {
        this.axios.put(`admin/events/${event.id}`, { important: event.important })
          .then(() => this.$notify.add('Atualizado!'))
      },
      copyText() {
        const text = window.getSelection().toString()
        if (!text) return
    
        const input = document.createElement('input');
        input.value = text
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
    
        this.$notify.add(`Copiado: "${text}"`)
      },
      find() {
        this.asyncTemplateSelect()
      },
      showDetail(event) {
        this.currentEvent = event
        this.showModal = true
      }
    },
    mixins: [ModelMapper],
    name: 'Events',
    watch: {
      allAccounts: {
        deep: true,
        handler(value) {
          this.filterAccount = this.buildFilterAccount(value.data)
        },
      },
      allUsers: {
        deep: true,
        handler(value) {
          this.filterEmail = this.buildFilterEmail(value.data)
        },
      }
    }
  }
</script>
